import { commTypes, receiverTypes } from './Constants'

/** The readable label of a channel or receiver type value ("whatsapp" -> "WhatsApp"); the value itself if unknown. */
export const optionLabel = (options, value) =>
    options.find((o) => o.value === value)?.label ?? value

export const channelLabel = (value) => optionLabel(commTypes, value)
export const receiverLabel = (value) => optionLabel(receiverTypes, value)

/**
 * The channel value a hand-off asked for, if `allowed` has it, else `fallback`.
 *
 * AI answers name channels loosely ("WhatsApp", "Push"), so the match ignores
 * case and accepts "push" for push notifications.
 */
export const channelFrom = (raw, allowed, fallback) => {
    if (typeof raw !== 'string') return fallback
    const value = raw.trim().toLowerCase()
    const normalised = value === 'push' ? 'push_notification' : value
    return allowed.includes(normalised) ? normalised : fallback
}

/**
 * What CRM Enrich hands to Audience Overlap: one identity type and only the
 * identities of that type.
 *
 * Audience Overlap checks a list against one index (email or mobile_no), so
 * a list mixing the two found nothing for half of it. Mobile wins when at
 * least as many found rows have one, as the CRM lookup is phone-first.
 *
 * Returns { identity_type: 'mobile_no' | 'email', identities: string[] }.
 */
export const overlapHandoff = (results) => {
    const found = (results ?? []).filter((r) => r.status === 'found')
    const mobiles = found.map((r) => r.mobile).filter(Boolean)
    const emails = found.map((r) => r.email).filter(Boolean)
    return mobiles.length >= emails.length
        ? { identity_type: 'mobile_no', identities: mobiles }
        : { identity_type: 'email', identities: emails }
}
